import css from "styled-jsx/css";

export const componentStyles = css.global`
  .product-title {
    padding: 10px 10px;
    display: flex;
    gap: 10px;
    cursor: pointer;
    align-items: flex-start;

    .product-tab-title-text {
      display: flex;
      height: 100%;
      justify-content: center;
      flex-direction: column;

      .product-tab-title {
        font-weight: 600;
        line-height: 24px;
      }
    }

    .picture-component {
      img {
        width: 44px;
        object-fit: contain;
      }
    }
  }
`;
